import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_commodity_price_flat_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { names?: string[], types?: string[], date_from?: string, date_to?: string, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { value1?: number, value2?: number, value3?: number, value4?: number, value5?: number, type?: string, date?: string, date_number?: number }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { names?: string[], types?: string[], date_from?: string, date_to?: string, full_text_search?: string, $keys: { type?: string, date?: string }[] }): Promise<{ result?: { value1?: number, value2?: number, value3?: number, value4?: number, value5?: number, type?: string, date?: string, date_number?: number }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      names?: string[], types?: string[], date_from?: string, date_to?: string, full_text_search?: string    }) {
      return false;
    }
}
